import {request} from './index';
import {ExamOverviewType} from './exam';
import {PagintionType} from '../utils';

export type LessonType = {
  id: number;
  name: string;
};

export type OptionOverviewType = {
  id: number;
  text: string;
  status: boolean;
  weight: number;
};

export type OptionType = OptionOverviewType & {
  isCorrect: boolean;
};

export type BaseQuestionType = {
  id: number;
  lesson: LessonType;
  question: string;
};

export type QuestionOverviewType = BaseQuestionType & {
  options: OptionOverviewType[];
};

export type QuestionType = BaseQuestionType & {
  options: OptionType[];
  answer: string;
};

export type StudentQuestionBaseType = {
  id: number;
  option: number | null;
  status: -1 | 0 | 1;
};

export type StudentQuestionOverviewType = StudentQuestionBaseType & {
  question: QuestionOverviewType;
  exam: number;
};

export type StudentQuestionType = StudentQuestionOverviewType & {
  question: QuestionType;
  exam: ExamOverviewType;
};

export async function fetchStudentQuestions<
  SQT extends StudentQuestionOverviewType | StudentQuestionType
>({
  queryKey: [_, { examId }],
  pageParam = 1
}: {
  queryKey: [string, { examId: number }];
  pageParam?: number;
}): Promise<PagintionType<SQT>> {
  return await request(true, {
    url: `/students/student-questions/e-${examId}?page=${pageParam}`
  });
}

export type updateStudentQuestionOptionDataType = {
  studentQuestionId: number;
  optionId: number | null;
  questionNumber: number;
};

export async function updateStudentQuestionOption({
  studentQuestionId,
  optionId
}: updateStudentQuestionOptionDataType): Promise<StudentQuestionOverviewType> {
  return await request(true, {
    method: 'PATCH',
    url: `/students/student-questions/${studentQuestionId}`,
    data: { option: optionId }
  });
}
